import CoraError from './coraError';
import * as storage from './storage';

/** @module utils/logger */

/**
 * Returns specific object. 
 * @function signOut
 * @returns {Object}
 */
const signOut = () => ({
  type: "SIGN_OUT"
});

/** VISCO 3 hidden action types 
 * @type {Object} */
const hiddenActionTypes = [
  'UPDATE_DAY_SUCCESS',
  'GET_MENU_SUCCESS',
];



/**
 * Akcie Loggeru
 */
export const loggerActions = {
  SHOW_MSG: "SHOW_MSG",
  HIDE_MSG: "HIDE_MSG"
};

/**
 * Dispatch pre hideMsg
 * @param {*} msg Sprava, ktora sa ma skryt
 * @returns 
 */
export const hideMsg = (msg) => ({
  type: loggerActions.HIDE_MSG,
  msg
});

/**
 * Dispatch pre showMsg
 * @param {*} msg Text spravy
 * @param {*} msgType Typ spravy 'ok'(default) | 'warning' | 'error'
 * @param {*} isDialog Ci sa ma sprava zobrazit ako dialogove okno
 * @param {*} title Titulok dialogu (default podla msgType)
 * @returns 
 */
export const showMsg = (msg, msgType = 'ok', isDialog = false, title = "") => ({
  type: loggerActions.SHOW_MSG,
  msg,
  msgType,
  isDialog,
  title
})


/* @param {Function} next next function to be executed
 * @param {Object} action action */

/**
 * Logs response of given action. Returns the result of next function.
 * @function logger
 * @param {Object} store redux store
 * @returns {*}
 */
const logger = store => next => action => {
  if (action.type.endsWith("FAILURE")) {
    if (action.error instanceof CoraError) {
      store.dispatch(showMsg(action.error.message, "error"));
      if (action.error.code === '401.000' && action.type !== 'SIGN_IN_FAILURE') {
        storage.removeUser();
        store.dispatch(signOut());
      }
    }
    else {
      store.dispatch(showMsg("Neočakávaná chyba.", "error"));
      if ([0, 1].includes(storage.getSrvCfg()?.envType)) { console.log(action.error); }
    }
  }
  else {
    if ((action.type.startsWith("CREATE") || action.type.startsWith("UPDATE") || action.type.startsWith("DELETE") || action.type.startsWith("CANCEL") || action.type.startsWith("UPLOAD") || action.type.startsWith("GENERATE") || action.type.startsWith("LINK")) && action.type.endsWith("SUCCESS") && !hiddenActionTypes.includes(action.type)) {
      if (action.res && action.res.UserMessage) {
        if (action.res.Code === '200.001') {
          store.dispatch(showMsg(action.res.UserMessage, "warning"));
        } else {
          store.dispatch(showMsg(action.res.UserMessage));
        }
      }
      else {
        store.dispatch(showMsg("OK"));
      }
    }
  }

  let result = next(action)
  return result
}

export default logger;



const initialState = {
  msg: []
};

/**
 * Reducer pre logger
 * @param {*} state 
 * @param {*} action 
 * @returns 
 */
export const loggerReducer = (state = initialState, action) => {
  switch (action.type) {
    case loggerActions.SHOW_MSG:
      const newMsg = { messageId: Date.now(), message: action.msg, messageType: action.msgType, isDialog: action.isDialog, title: action.title };
      return { msg: [newMsg, ...state.msg] };
    case loggerActions.HIDE_MSG:
      return { msg: state.msg.filter(x => x.messageId !== action.msg.messageId) };

    default:
      return state;
  }
};